import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { canAcceptCreditCard } from "../../utils/providers";
import "./Upload.css";

export const DocumentUploadSuccess = ({
  documentUploadTypeId,
  user,
  documentUploadTypes,
}) => {
  const documentUploadType = documentUploadTypes.find(
    (d) => d.id.toString() === documentUploadTypeId,
  );

  const handleReset = () => {
    window.location.reload();
  };

  return (
    <div className="section container">
      <Row className="section border-between">
        <Col sm={12} className="contract-details">
          <h2 style={{ marginTop: "30px", marginBottom: "20px" }}>
            We received your {documentUploadType} submission.
          </h2>
          <p>
            If we have any questions regarding your submission, we will contact
            you to obtain any additional information needed for processing.
          </p>
          <p>
            Need to upload another document?{" "}
            <a className="cursor" onClick={handleReset}>
              Click here
            </a>
            .
          </p>
          {user?.customers &&
            user.customers.length > 0 &&
            user.acceptCreditCard &&
            canAcceptCreditCard(user.customers) && (
              <Row>
                <Col>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      padding: "14px 18px",
                      background: "#f0f6fc",
                      borderRadius: "10px",
                      border: "1px solid #cce0f5",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#1a1a2e",
                          marginBottom: "2px",
                        }}
                      >
                        Credit card payment
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "var(--upload-text-muted)",
                        }}
                      >
                        Click the button to make a secure credit card
                        payment.{" "}
                      </div>
                    </div>
                    <Link
                      to={"/payment"}
                      target="_blank"
                      rel="noopener"
                      id="checkout_button"
                      className="btn btn-sm"
                      style={{
                        fontSize: "13px",
                        backgroundColor: "#367bb0",
                        color: "white",
                        borderRadius: "4px",
                        padding: "7px 18px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Make a payment
                    </Link>
                  </div>
                </Col>
              </Row>
            )}
        </Col>
      </Row>
    </div>
  );
};
